export enum CommsTypeEnum {
  Email = 1,
  SMS = 2,
  Push = 3,
}

export const CommsTypeName = {
  1: 'Email (HTML)',
  2: 'SMS Text',
  3: 'Push Notification',
};
